import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { computedFn } from "mobx-utils";
import { EmploymentStatusEnum } from "Globals/Models/EmploymentStatusEnum";

export class SelectItemsStore extends BaseStore {
    public constructor() {
        super();
    }

    private genderSameAsBith = MobX.observable<KeyValuePair>([
        { key: "Please select", value: "placeholder" },
        { key: "Yes", value: "yes" },
        { key: "No", value: "no" },
        { key: "Prefer not to say", value: "prefernottosay" },
    ]);
    @MobX.computed
    public get getGenderSameAsBithOptions(): KeyValuePair[] {
        return this.genderSameAsBith;
    }
    private genders = MobX.observable<KeyValuePair>([
        { key: "Please select", value: "placeholder" },
        { key: "Male", value: "male" },
        { key: "Female", value: "female" },
        { key: "Prefer not to say", value: "prefernottosay" },
    ]);
    @MobX.computed
    public get getGenderOptions(): KeyValuePair[] {
        return this.genders;
    }
    @MobX.action
    public getGenderName(genderValue: string | null): string {
        if (genderValue === null) return "Unknown";
        let gender = this.getGenderOptions.find((gender) => genderValue === gender.value);
        return gender ? gender.key : "Unknown";
    }

    private titles = MobX.observable<KeyValuePair>([
        { key: "Please select", value: "placeholder" },
        { key: "Miss", value: "Miss" },
        { key: "Mr", value: "Mr" },
        { key: "Mrs", value: "Mrs" },
        { key: "Ms", value: "Ms" },
        { key: "Dr", value: "Dr" },
        { key: "Rev", value: "Rev" },
    ]);
    @MobX.computed
    public get getTitleOptions(): KeyValuePair[] {
        return this.titles;
    }

    /**
     * Shared ownership
     */
    @MobX.computed
    public get getSharedOwnershipOptions(): KeyValuePair[] {
        let months = MobX.observable<KeyValuePair>([]);
        for (let index = 0; index <= 100; index += 5) {
            months.push({ key: `${index}%`, value: index });
        }
        return months;
    }

    private employmentStatus = MobX.observable<KeyValuePair>([
        { key: "Please select", value: EmploymentStatusEnum.Empty },
        { key: "Full-time work (over 30 hours per week)", value: EmploymentStatusEnum.FullTime },
        { key: "Part-time work (less than 30 hours per week)", value: EmploymentStatusEnum.PartTime },
        { key: "Government Training/New Deal", value: EmploymentStatusEnum.GovernmentTraining },
        { key: "Job Seeker", value: EmploymentStatusEnum.JobSeeker },
        { key: "Retired", value: EmploymentStatusEnum.Retired },
        { key: "Not seeking work", value: EmploymentStatusEnum.NotSeekingWork },
        { key: "Full-time student", value: EmploymentStatusEnum.FullTimeStudent },
        { key: "Unable to work due to long-term sickness or disability", value: EmploymentStatusEnum.UnableToWork },
        { key: "Child under 16", value: EmploymentStatusEnum.Child },
        { key: "Self-employed", value: EmploymentStatusEnum.SelfEmployed },
        { key: "Other", value: EmploymentStatusEnum.Other },
    ]);
    @MobX.computed
    public get getEmploymentStatusOptions(): KeyValuePair[] {
        return this.employmentStatus;
    }

    /**
     * Get year options for a select item input
     * @param {number} start Inclusive start year
     * @param {number} end Inclusive end year
     */
    @MobX.action
    public getYearOptions = (start: number = 0, end: number = 100): KeyValuePair[] => {
        let years = MobX.observable<KeyValuePair>([]);
        for (let index = start; index <= end; index++) {
            years.push({ key: `${index} years`, value: index.toString() });
        }
        return years;
    };

    /**
     * Get month options for a select item input
     */
    @MobX.computed
    public get getMonthOptions(): KeyValuePair[] {
        let months = MobX.observable<KeyValuePair>([]);
        for (let index = 0; index <= 11; index++) {
            months.push({ key: `${index} months`, value: index.toString() });
        }
        return months;
    }
    // 0, 3, 6, and 9 months
    private probationMonth = MobX.observable<KeyValuePair>([
        { key: "0 months", value: 0 },
        { key: "3 months", value: 3 },
        { key: "6 months", value: 6 },
        { key: "9 months", value: 9 },
    ]);
    @MobX.computed
    public get getProbationMonthOptions(): KeyValuePair[] {
        return this.probationMonth;
    }
}
